module.exports = __webpack_public_path__ + "3e4c8d5daf0fae7e411dcd4bfae8fa4e.pdf";